export default __webpack_public_path__ + "static/media/contactPeople.2677622d.svg";